import "../assets/css/loading.css";
const Loading = () => {
  return (
    <div className="loadings" role="status" aria-live="polite" aria-label="Loading">
      <span style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0,0,0,0)",
        whiteSpace: "nowrap",
        border: 0,
      }}>
        Loading...
      </span>
    </div>
  );
};

export default Loading;
